import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=4390b8e8&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4390b8e8')) {
      api.createRecord('4390b8e8', component.options)
    } else {
      api.reload('4390b8e8', component.options)
    }
    module.hot.accept("./toolbar.vue?vue&type=template&id=4390b8e8&", function () {
      api.rerender('4390b8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/toolbar.vue"
export default component.exports